export const attributionGroupTxt = {
  DELETE_VALIDATION_DIALOG_TITLE: "Unable to delete some attribution groups",
  DELETE_VALIDATION_DIALOG_CONTENT:
    "Some attribution groups are used in other content types and can’t be deleted. Remove the attribution groups from where they are used in order to delete.",
  DONE: "Done",
  DUPLICATE_SUCCESSFUL: "Attribution group was duplicated successfully",
};
